import {z} from '@hono/zod-openapi';

/**
 * E.164 telephone number: a leading `+`, then 2 to 15 digits, the first of which is non-zero.
 * Shared by the voice Kafka contract schemas that carry a called or caller number.
 */
const E164_PHONE_NUMBER_PATTERN = /^\+[1-9]\d{1,14}$/;

export const E164PhoneNumberSchema = z
  .string()
  .regex(E164_PHONE_NUMBER_PATTERN)
  .openapi('E164PhoneNumberSchema', {example: '+420800123456'});
